<template>
  <footer
    class="form-page__footer"
    :class="{ 'form-page__footer--shadow': shadow }"
  >
    <div class="form-page__footer__container">
      <div class="text--right">
        <a
          v-if="status !== isLoading"
          :title="$t('Common.cancel')"
          class="mr-2"
          @click.prevent="cancel"
        >
          {{ $t('Common.cancel') }}
        </a>

        <Button
          type="submit"
          :disabled="status === isLoading"
          :loading="status === isLoading"
          @click="submit"
        >
          {{ $t(`${namespace}.submitButtonLabel`) }}
        </Button>
      </div>
    </div>
  </footer>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'EmployeeMassCreditPolicyFooter',
  props: {
    kind: {
      type: String
    },
    status: {
      type: Number
    }
  },
  computed: {
    isLoading: () => STATUS_IS_LOADING,
    isSuccess: () => STATUS_SUCCESS,
    isFailed: () => STATUS_FAILED
  },
  data () {
    return {
      namespace: 'Views.EmployeeMassCreditPolicyPage',
      shadow: true
    }
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },

    submit () {
      this.$emit('submit')
    },

    handleShadow () {
      this.shadow = !((window.innerHeight + window.scrollY) >= document.body.scrollHeight)
    }
  },
  mounted () {
    this.handleShadow()
    window.addEventListener('scroll', this.handleShadow)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleShadow)
  }
}
</script>
